import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IHtmlProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IHtmlProps>>
): IComponentSchema<IHtmlProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Html',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Html,
    'x-component-props': {
      html: '<p>Text</p>',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
